




























import { Component, Mixins, Watch } from "vue-property-decorator";
import { CalculateItem } from "../../../../domain/document/items";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { CalculateObjectStyleReader } from "../styleReaders";
import {
  StyledTextEditableObjectMixin,
  DataValidatableMixin
} from "./mixins";
import { CalculateKinds, NumericInputFormatter } from "../../../../domain/document";
import TextInputArea from "./TextInputArea.vue";
import { IFreeInputableObject } from "./IFreeInputableObject";

@Component({
  components: {
    TextInputArea,
  }
})
export default class CalculateObject extends Mixins(
  StyledTextEditableObjectMixin,
  DataValidatableMixin
) implements IFreeInputableObject {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new CalculateObjectStyleReader(configuration.style.document.editor.objects.calculate);
  }

  editingSource: CalculateItem;

  updateInputElement(value: HTMLInputElement): void {
    this.inputableElement = value;
  }

  @Watch("isFocused")
  updateIsFocused(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.adjustTextFontSize();
    }
  }

  get displayText(): string {
    this.updateTextPositionHeight();
    return this.shouldInputFreeSelfOrAll ? this.freeInputText
      : this.isNameDisplay ? this.displayName
      : this.isNormalDisplay ? this.freeInputText
      : this.$configuration.wording.document.editor.displayTextForCalculationError;
  }

  set displayText(value: string) {
    this.freeInputText = value;
  }

  @Watch("shouldInputFreeAll")
  updatedshouldInputFreeAll(newValue: string, oldValue: string): void {
    this.writeProperty(s => s.shouldInputFreeAll = newValue);
  }

  @Watch("freeInputText")
  updatedFreeInputText(newValue: string, oldValue: string): void {
    this.changeToNumericFormat();
  }

  @Watch("shouldInputFreeSelfOrAll")
  updatedShouldInputFreeSelfOrAll(newValue: boolean, oldValue: boolean): void {
    this.changeToNumericFormat();
  }
  
  /** 表示形式を変更する */
  changeToNumericFormat(): void {
    if (this.shouldInputFreeSelfOrAll) { return; }
    if (this.editingSource.calculateKind !== CalculateKinds.Calculate) {
      // 計算式以外は文字列を含むので、計算式のみ表示形式を変換する
      return;
    }
    
    if (this.freeInputText.indexOf("e+") >= 0 || this.freeInputText.indexOf("e-") >= 0) {
      // 大きな桁数の時は1111111～～e+30のような表示になって意図した表示にならないので、暫定対策でそのまま表示する
      return;
    }
    const formatted = NumericInputFormatter.format(this.freeInputText, this.editingSource.numericFormat);
    if (this.freeInputText !== formatted) {
      this.writeProperty(s => s.value = formatted);
    }
  }

  get freeInputText(): string {
    // numberの0のときもあるので注意！
    if (this.editingSource.value === undefined || this.editingSource.value === null) { return ""; }
    return this.editingSource.value.toString();
  }

  set freeInputText(value: string) {
    this.writeProperty((s: CalculateItem) => {
      if (this.shouldInputFreeSelfOrAll && this.isFreeInputable) {
        // 「全てフリー入力」でフリー入力になっている状態で手入力されたときはフリー入力にする
        s.shouldInputFree = true;
      }
      s.value = this.validateText(this.editingSource, value);
      s.adjustFontSize();
    });
  }

  adjustTextFontSize(): void {
    if (this.editingSource.value && this.shouldInputFreeSelfOrAll) {
      this.autoAdjustFontSize();
    }
  }

  get isNormalDisplay(): boolean {
    const isConditional = (this.editingSource.calculateKind === CalculateKinds.Conditional);
    const hasValue = (this.editingSource.value !== null) && (this.editingSource.value !== undefined);
    return isConditional || this.shouldInputFreeSelfOrAll || hasValue;
  }

  get isNameDisplay(): boolean {
    return (this.editingSource.calculateKind === CalculateKinds.Conditional) && (this.editingSource.value === null || this.editingSource.value === undefined);
  }

  get displayName(): string {
    return this.editingSource.name;
  }

  pasteText(value: string): void {
    this.insertTextToCaretPosition(value);
    this.$nextTick(() => {
      this.adjustTextFontSize();
    });
  }

  overwriteText(value: string, isForcibly?: boolean): void {
    console.error("overwriteTextは実装されていません。");
  }
}
